module.exports = __webpack_public_path__ + "img/uk-dining-4.82abb0cb.png";